
/**
    Table of Contents

    Copyright (c) 2020 Kamochan https://cookbook88.com/

    This software is released under the MIT License.
    http://opensource.org/licenses/mit-license.php
*/

{
    const TOC_INSERT_SELECTOR = '#toc';
    const tocInsertElement = document.querySelector(TOC_INSERT_SELECTOR);
    const tocTarget = document.querySelector('#toc_target');
    let tocInsertElementSP = document.querySelector('#tocSP');
    let HEADING_SELECTOR = 'h1,h2,h3';
    if( document.getElementById("tocSPh3") !== null ){
        HEADING_SELECTOR = 'h1,h2';
        tocInsertElementSP = document.querySelector('#tocSPh3');
        console.log("h3を含めない");
    }
    const LINK_CLASS_NAME = 'tocLink';
    const ID_NAME = 'heading';
    const headingElements = tocTarget.querySelectorAll(HEADING_SELECTOR);
    const layer = [];
    let id = 0;
    const uid   = () =>`${ID_NAME}${id++}`;
    let links = null;
    let linksDesktop = null;
    let oldRank = -1;
    try {
        const createLink = (el) => {
            let li = document.createElement('li');
            let a  = document.createElement('a');
            el.id  = el.id || uid();
            a.href = `#${el.id}`;
            a.innerText = el.innerText;
            a.className = LINK_CLASS_NAME;
            li.appendChild(a);
            return li;
        };
        const findParentElement = (layer, rank, diff) => {
            do {
                rank += diff;
                if (layer[rank]) return layer[rank];
            } while (0 < rank && rank < 7);
            return false;
        };
        const appendToc = (el, toc) => {
            el.appendChild(toc.cloneNode(true));
        };
        const tocHighlight = (e) => {
            const sy = window.pageYOffset;
            const ey = sy + document.documentElement.clientHeight;
            let tocHighlightEl = null;
            linksDesktop.forEach( (el) => {
                const targetEl = document.querySelector(el.hash);
                const y = sy + targetEl.getBoundingClientRect().top ;
                el.classList.remove("active") ;
                if(sy < y &&  y < ey)tocHighlightEl = el;
                if(sy > y) tocHighlightEl = el;
            });
            if(tocHighlightEl)tocHighlightEl.classList.add("active");
        };
        headingElements.forEach( (el) => {
            let rank   = Number(el.tagName.substring(1));
            let parent = findParentElement(layer, rank, -1);
            if (oldRank > rank) layer.length = rank + 1;
            if (!layer[rank]) {
                layer[rank] = document.createElement('ol');
                if (parent.lastChild) parent.lastChild.appendChild(layer[rank]);
            }
            layer[rank].appendChild(createLink(el));
            oldRank = rank;
        });
        if (layer.length && tocInsertElementSP) appendToc(tocInsertElementSP, findParentElement(layer, 0, 1));
        if (layer.length) appendToc(tocInsertElement, findParentElement(layer, 0, 1));

        links = document.querySelectorAll(`.${LINK_CLASS_NAME}`);
        linksDesktop = document.querySelectorAll("#toc .tocLink");
        links.forEach((el) => {
            el.addEventListener("click",(e)=>{
                const targetEl = document.querySelector(el.hash);
                scrollTo(0, window.pageYOffset + targetEl.getBoundingClientRect().top - 100);
                e.preventDefault();
                e.stopPropagation();
            });
        });
        tocHighlight();
        window.addEventListener("scroll", tocHighlight);
    } catch (e) {
        //error 
    }
}